import {
  AD_CREATIVES,
  CLICK_THROUGH_LINK,
  CREATIVE_TYPE_VIDEO,
  MEDIA_HEIGHT,
  MEDIA_WIDTH,
  NAME,
  THIRD_PARTY_TAG
} from '../../../../fields'
import {
  DISPLAY_DEFAULT,
  VIDEO_DEFAULT
} from '../../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'
import { IS_QUARANTINE } from '../../../../../../reusableFields'

export const transformValuesToBE = ({
  values,
  lineItemType,
  campaignId,
  lineItemId,
  account,
  rightsHolderId,
  isInternalAdCreation
}) => {
  return {
    creatives: values[AD_CREATIVES].map(ad => ({
      rights_holder_account_id: rightsHolderId,
      account_id: rightsHolderId,
      // isInternalAdCreation is default, also allow to pass it manually if user has ability to select it(values[IS_QUARANTINE])
      quarantine: isInternalAdCreation || values[IS_QUARANTINE],
      account,
      campaign_id: campaignId,
      line_item_id: lineItemId,
      name: ad[NAME],
      status: 'active',
      type: lineItemType === VIDEO_DEFAULT ? CREATIVE_TYPE_VIDEO : 'CREATIVE_TYPE_STANDARD',
      hosting_source: 'HOSTING_SOURCE_THIRD_PARTY',
      ...(lineItemType === DISPLAY_DEFAULT && {
        dimensions: {
          [MEDIA_WIDTH]: ad[MEDIA_WIDTH],
          [MEDIA_HEIGHT]: ad[MEDIA_HEIGHT]
        },
        exit_events: [
          {
            type: 'EXIT_EVENT_TYPE_BACKUP',
            url: ad[CLICK_THROUGH_LINK]
          }
        ],
        third_party_tag: ad[THIRD_PARTY_TAG]
      }),
      // For video type lineItems we create VAST tag ad creatives,
      // and use vast_tag_url instead of third_party_tag
      ...(lineItemType === VIDEO_DEFAULT && {
        vast_tag_url: ad[THIRD_PARTY_TAG]
      })
    }))
  }
}
